import React from "react";
import { motion } from "framer-motion";
import { Briefcase } from "lucide-react";
import { Section, SectionHeading } from "./_shared";

const Experience = ({ items = [] }) => {
  return (
    <Section id="experience">
      <SectionHeading
        index="02"
        label="Experience"
        title="Where I've shipped."
        description="A growing track record of building intelligent systems alongside world-class teams."
        testId="experience-heading"
      />

      <div className="relative">
        <div className="absolute left-3 md:left-1/2 md:-translate-x-px top-2 bottom-2 w-px bg-gradient-to-b from-cyan-400/40 via-violet-500/30 to-transparent" />
        <div className="space-y-12">
          {items.map((exp, i) => {
            const isLeft = i % 2 === 0;
            return (
              <motion.div
                key={exp.id || i}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="relative grid md:grid-cols-2 gap-6 md:gap-12"
                data-testid={`experience-item-${i}`}
              >
                <div className="absolute left-3 md:left-1/2 md:-translate-x-1/2 top-3 -translate-x-1/2">
                  <div className="w-3 h-3 rounded-full bg-gradient-to-br from-cyan-400 to-violet-500 pulse-dot" />
                </div>
                <div className={`pl-10 md:pl-0 ${isLeft ? "md:pr-12 md:text-right" : "md:col-start-2 md:pl-12"}`}>
                  <div className="glass glass-hover rounded-2xl p-6 md:p-7">
                    <div className={`flex flex-wrap items-center gap-2 mb-3 ${isLeft ? "md:justify-end" : ""}`}>
                      <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-cyan-300">{exp.period}</span>
                      {exp.location && <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500">· {exp.location}</span>}
                    </div>
                    <h3 className="font-display text-2xl md:text-3xl tracking-tight text-white font-medium">{exp.role}</h3>
                    <div className="mt-1 flex items-center gap-2 text-cyan-300 text-sm font-medium" style={{ justifyContent: isLeft ? "flex-end" : "flex-start" }}>
                      <Briefcase size={14} />
                      {exp.company}
                    </div>
                    <ul className={`mt-4 space-y-2 text-[14px] text-slate-300 leading-relaxed ${isLeft ? "md:text-right" : ""}`}>
                      {(exp.highlights || []).map((h, k) => <li key={k}>{h}</li>)}
                    </ul>
                    {(exp.tags || []).length > 0 && (
                      <div className={`mt-5 flex flex-wrap gap-2 ${isLeft ? "md:justify-end" : ""}`}>
                        {(exp.tags || []).map((t) => (
                          <span key={t} className="px-2.5 py-1 text-[11px] font-mono rounded-full border border-white/10 bg-white/[0.03] text-slate-300">{t}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </Section>
  );
};

export default Experience;
